import { useCallback } from 'react'

import { browserHistory } from 'react-router'

import type { SubscriptionSettingsAnalytics } from '@library/api-customer-engagement-experience'
import { queueTrackingEvent } from '@library/tracking-integration'

export const RESUBSCRIPTION_MODAL_INTENTS = {
  dismiss: 'dismiss_resubscription_modal',
  navigateToDashboard: 'navigate_to_dashboard',
} as const

const DASHBOARD_DESTINATION = '/my-gousto'

type UseResubscriptionModalIntentHandlerResult = {
  onAction: (intent: string, analytics?: SubscriptionSettingsAnalytics) => void
}

export function useResubscriptionModalIntentHandler(
  onClose: () => void,
): UseResubscriptionModalIntentHandlerResult {
  const onAction = useCallback(
    (intent: string, analytics?: SubscriptionSettingsAnalytics): void => {
      switch (intent) {
        case RESUBSCRIPTION_MODAL_INTENTS.dismiss:
          if (analytics) {
            queueTrackingEvent<SubscriptionSettingsAnalytics>(analytics)
          }
          onClose()

          return

        case RESUBSCRIPTION_MODAL_INTENTS.navigateToDashboard:
          if (analytics) {
            queueTrackingEvent<SubscriptionSettingsAnalytics>(analytics)
          }
          onClose()
          browserHistory.push(DASHBOARD_DESTINATION)

          return

        default:
          return
      }
    },
    [onClose],
  )

  return { onAction }
}
